export type HubFilePreviewKind = "pdf" | "image" | "text" | "none";

const TEXT_EXTENSIONS = new Set([
  "asc",
  "txt",
  "csv",
  "md",
  "log",
  "json",
  "xml",
  "css",
  "js",
  "ts",
  "tsx",
  "yaml",
  "yml",
]);

function filenameExtension(filename: string): string | null {
  const match = /\.([^.]+)$/i.exec(filename.trim());
  return match ? match[1]!.toLowerCase() : null;
}

export function inferHubFilePreviewKind(
  filename: string,
  contentType?: string | null,
): HubFilePreviewKind {
  const mime = (contentType ?? "").toLowerCase();
  const extension = filenameExtension(filename) ?? "";
  if (mime.includes("pdf") || extension === "pdf") return "pdf";
  if (mime.startsWith("image/")) return "image";
  if (/\.(png|jpe?g|webp|gif|bmp|svg)$/i.test(filename)) return "image";
  if (mime.startsWith("text/") || TEXT_EXTENSIONS.has(extension)) return "text";
  return "none";
}

export function isHubFilePreviewable(filename: string, contentType?: string | null): boolean {
  return inferHubFilePreviewKind(filename, contentType) !== "none";
}

/** Chrome/Edge PDF viewer open parameters that collapse the thumbnail sidebar. */
const HIDDEN_PDF_SIDEBAR_HASH = "navpanes=0&pagemode=none";

export function hubPdfPreviewUrl(
  previewUrl: string,
  options?: { hideSidebar?: boolean },
): string {
  if (!options?.hideSidebar) {
    return previewUrl;
  }
  const hashIndex = previewUrl.indexOf("#");
  const base = hashIndex === -1 ? previewUrl : previewUrl.slice(0, hashIndex);
  const existingHash = hashIndex === -1 ? "" : previewUrl.slice(hashIndex + 1);
  if (/(?:^|&)(?:pagemode|navpanes)=/i.test(existingHash)) {
    return previewUrl;
  }
  return existingHash
    ? `${base}#${existingHash}&${HIDDEN_PDF_SIDEBAR_HASH}`
    : `${base}#${HIDDEN_PDF_SIDEBAR_HASH}`;
}
